// extracted by mini-css-extract-plugin
export default {"wrapper":"SetRefPrice_wrapper__4tYEE"};